import { gql } from '@apollo/client';
import { ProductionOrderInfoPartner } from '../fragments';

export default gql`
  query productionOrder($id: ID) {
    productionOrder(id: $id) {
        ...ProductionOrderInfoPartner
    }
  }
  ${ProductionOrderInfoPartner}
`;
